import { z } from '@betty/toolkit/api';

export const AccountStatusSchema = z.enum([
  'Pending',
  'Approved',
  'Suspended',
  'Timeout',
  'SelfExclusion',
  'Closed',
]);

export const AccountStatusReasonSchema = z.enum([
  'KYC Address Mismatch',
  'KYC incomplete',
  'KYC in progress',
  'KYC Verification Pending',
  'Document Verification Failed',
  'Manual Verification Required',
  'Within AML Assessment',
  'Security Review Required',
  'Under Security Review',
  'Restricted for Security Review',
  'Restricted - Manual Verification Required',
  'Restricted - Document Verification Failed',
  'Under Security Review - Manual Verification Required',
  'Under Security Review - Document Verification Failed',
  'Under Security Review - KYC in progress',
  'Restricted - KYC in progress',
  'Pending Document Verification Review',
]);

export const RegistrationResponseSchema = z.object({
  status: AccountStatusSchema,
  statusReason: AccountStatusReasonSchema,
  accountId: z.number(),
});
